import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 100;
    display: none;

    &.opened {
        display: block;
    }
`;

export const Window = styled.div`
    display: none;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 850px;
    height: 90%;
    max-height: 620px;
    background-color: #111;
    border: 1px solid #333;
    z-index: 101;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        display: flex;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    background-color: #333;
    height: 30px;
    width: 100%;
`;

export const HeaderTitle = styled.div`
    padding-left: 5px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
`;

export const ButtonBar = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #333;
    width: 100%;
`;

export const ButtonRow = styled.div`
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${p => p.justify ?? 'center'};
`;

export const Button = styled.label`
    border: 1px solid ${p => p.color ?? "#fff"};
    color: ${p => p.color ?? "#fff"};
    padding: 0 15px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s ease 0s;
    margin-right: 10px;

    :hover {
        color: #fff;
        background-color: ${p => p.color ?? "#fff"};
    }

    &:last-child {
        margin-right: 0;
    }
`;

export const Content = styled.div`
    flex: 1;
    width: 100%;
    height: calc(100% - 100px);
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    padding: 20px 0;
`;

export const Alert = styled.div`
    max-width: 250px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
`;
